
import React from 'react';
import Draggable from 'react-draggable';
import { changeShapeFillVisibility, updateCurrentSlideThumbnail } from '../../actions/CurrentSlideActions';
import { useBackgroundAsImage, useFrameAsImage, useImageAsBackground, useVideoAsBackground, groupDrawingShapes } from '../../actions/MenuActions';
import storeManager from '../../store/StoreManager';
import locales from '../../locales/LocalesManager';
import platformDetection from '../../components/utils/PlatformDetection';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';

export const OnOffToggleButton = React.createClass({
    getInitialState () {
        return {
            state: 'off',
            isThumbOver: false
        };
    },
    onThumbMouseIn () {
        this.setState({
            isThumbOver: true
        });
    },
    onThumbMouseOut () {
        this.setState({
            isThumbOver: false
        });
    },
    onKeyDown(e) {
        if (e.keyCode == 32 || e.keyCode == 13) // Space or Enter Key
            this.onChangeValue();
    },
    onMouseDown() {
        var leftString = this.refs.thumb.style.left;
        var left = Number(leftString.substring(0, leftString.length - 2));

        this.setState({
            startPosition: left,
            isON: this.isON()
        });
    },
    updateThumbnail() {
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    checkPosition(deltaX) {
        saveManager.isContentChanged(true);

        const newPosition = (this.state.startPosition +  deltaX);
        const limit = this.props.properties.trackWidth / 2;
        var value;

        if (newPosition + this.props.properties.thumbSize / 2 > limit) {
            value = true;
            this.refs.thumb.style.left = this.props.properties.trackWidth - this.props.properties.thumbSize + 'px';
        } else {
            value = false;
            this.refs.thumb.style.left = '0px';
        }

        if (this.props.properties.isBackgroundElement || this.props.properties.isMediaFilesElement)
            value = !value;

        if (this.state.isON != value) {
            if (this.props.properties.isDrawing) {
                this.props.dispatch(groupDrawingShapes(value));
            } else {
                if (this.props.properties.isMediaFilesElement) {
                    if (this.props.properties.isVideo)
                        this.props.dispatch(useVideoAsBackground(!value));
                    else
                        this.props.dispatch(useImageAsBackground(!value));
                } else {
                    if (this.props.properties.isBackgroundElement) {
                        if (this.props.properties.isFrame)
                            this.props.dispatch(useFrameAsImage(value));
                        else
                            this.props.dispatch(useBackgroundAsImage(value));
                    } else {
                        this.props.dispatch(changeShapeFillVisibility(this.props.shapeModel.uuid, value));
                        this.updateThumbnail();
                        audioEditorUtils.addActionToHistory();
                    }
                }
            }

            this.setState({
                isON: value
            });

            this.forceUpdate();
        }
    },
    onMouseMove(e, coreEvent) {
        this.checkPosition(coreEvent.lastX);
    },
    onMouseUp(e, coreEvent) {
        this.checkPosition(coreEvent.lastX);
    },
    isON() {
        if (this.props.properties.isDrawing) {
            return this.props.properties.groupDrawingShapes;
        }

        if (this.props.properties.isBackgroundElement) {
            if (this.props.properties.isFrame)
                return !this.props.properties.useFrameAsImage;
            else
                return !this.props.properties.useBackgroundAsImage;
        }

        if (this.props.properties.isMediaFilesElement) {
            if (this.props.properties.isVideo)
                return this.props.properties.useVideoAsBackground;
            else
                return this.props.properties.useImageAsBackground;
        }

        if (this.props.shapeModel == undefined)
            return false;

        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        var target;
        var i;

        for (i=0; i<shapes.length; i++)
            if (shapes[i].uuid == this.props.shapeModel.uuid) {
                target = shapes[i];
                break;
            }

        if (target && target.backgroundVisible == false)
            return false;
        else
            return true;
    },
    onChangeValue() {
        saveManager.isContentChanged(true);

        var value = !this.state.isON;

        if (this.state.isON === undefined) {
            if (this.props.properties.isMediaFilesElement && this.props.properties.isVideo)
                value = false;
        }

        if (this.props.properties.isDrawing) {
            this.props.dispatch(groupDrawingShapes(value));
        } else {
            if (this.props.properties.isMediaFilesElement) {
                if (this.props.properties.isVideo)
                    this.props.dispatch(useVideoAsBackground(value));
                else
                    this.props.dispatch(useImageAsBackground(value));
            } else {
                if (this.props.properties.isBackgroundElement) {
                    if (this.props.properties.isFrame)
                        this.props.dispatch(useFrameAsImage(value));
                    else
                        this.props.dispatch(useBackgroundAsImage(value));
                } else {
                    this.props.dispatch(changeShapeFillVisibility(this.props.shapeModel.uuid, value));
                    this.updateThumbnail();
                }
            }
        }

        this.forceUpdate();

        this.setState({
            isON: value
        });
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isThumbOver != nextState.isThumbOver || this.state.isON != nextState.isON || this.props.shapeModel != newProps.shapeModel || this.props.properties != newProps.properties)
            return true;
        else
            return false;
    },
    render() {
        const properties = this.props.properties;

        const textWidth = 35;

        var wrapperStyle = {
            position: 'absolute',
            left: properties.leftPosition,
            top: properties.topPosition,
            width: properties.trackWidth + textWidth,
            height: properties.thumbSize,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        var textStyle = {
            position: 'absolute',
            left: 0,
            top: 4,
            fontSize: 16,
            cursor: 'default'
        };

        var buttonStyle = {
            position: 'absolute',
            left: textWidth,
            top: 0
        };

        var thumbPosition = 0;
        var stateValue = locales.getCaption('OFF', 'other');
        const textValueOffset = 4;
        var stateLeftPosition = this.props.properties.thumbSize + textValueOffset / 2;
        var backgroundColor = '#A3A3A3';

        if (this.isON() == true) {
            thumbPosition = this.props.properties.trackWidth - this.props.properties.thumbSize;
            stateValue = locales.getCaption('ON', 'other');
            stateLeftPosition = textValueOffset;
            backgroundColor = '#A5D3CF';
        }

        const backgroundStyle = {
            position: 'absolute',
            width: properties.trackWidth,
            height: properties.trackHeight,
            top: properties.thumbSize / 2 - properties.trackHeight / 2,
            backgroundColor: backgroundColor,
            borderRadius: 30
        };

        const thumbBorderSize = 2;
        var thumbBorderColor = 'black';

        if (this.state.isThumbOver == true)
            thumbBorderColor = '#2196F3';

        const thumbStyle = {
            position: 'absolute',
            width: properties.thumbSize - 2 * thumbBorderSize,
            height: properties.thumbSize - 2 * thumbBorderSize,
            top: 0,
            left: thumbPosition,
            background: 'white',
            borderStyle: 'solid',
            borderColor: thumbBorderColor,
            borderWidth: 2,
            borderRadius: 50,
            cursor: 'default',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial'
        };

        var textStateStyle = {
            position: 'absolute',
            left: stateLeftPosition,
            top: 4,
            fontSize: 14,
            cursor: 'default'
        };

        var backgroundImageText;
        var fillTextBackground;

        if (properties.isMediaFilesElement || properties.isDrawing || properties.isBackgroundElement) {
            if (properties.isDrawing) {
                backgroundImageText = <span style={textStyle}>{locales.getCaption('group', 'drawing')}</span>;
            } else {
                if (properties.isBackgroundElement) {
                    backgroundImageText = <span style={textStyle}>{locales.getCaption('UseAsBackground', 'other')}</span>;
                } else {
                    if (properties.isVideo)
                        backgroundImageText = <span style={textStyle}>{locales.getCaption('UseVideoAsBackground', 'other')}</span>;
                    else
                        backgroundImageText = <span style={textStyle}>{locales.getCaption('UseImageAsBackground', 'other')}</span>;
                }
            }

            buttonStyle.left = 0;
            textStyle.left = properties.trackWidth + 7;
            textStyle.fontSize = 14;
            wrapperStyle.width = properties.width;

            if (platformDetection.isIOS()) {
                textStyle.top = 6;
                textStyle.fontSize = 12;
                textStyle.left = textStyle.left - 5;
            }
        } else
            fillTextBackground = <span style={textStyle}>{locales.getCaption('FillTextBackground', 'textStylingMenu')}</span>;

        const topFrame = {
            position: 'absolute',
            width: properties.trackWidth,
            height: properties.trackHeight + 4
        };

        return (
            <div style={wrapperStyle}>
                {fillTextBackground}
                <div style={buttonStyle}>
                    <div ref='track' style={backgroundStyle} />
                    <span style={textStateStyle}>{stateValue}</span>
                    <Draggable axis="none" position={{x:0, y:0}} onStop={this.onChangeValue}>
                        <div style={topFrame}/>
                    </Draggable>
                    <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                        <button id={this.props.id} aria-label={stateValue} ref='thumb' style={thumbStyle} onKeyDown={this.onKeyDown} onMouseOver={this.onThumbMouseIn} onMouseOut={this.onThumbMouseOut}/>
                    </Draggable>
                </div>
                {backgroundImageText}
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/OnOffToggleButton.js
 **/